export const styles = {
  noAppIdWrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10%',
    paddingTop: 0,
    textAlign: 'center'
  },
};
